import * as Yup from "yup"
import ProductContent from "./ProductContent";
import { PriceHelper } from "../../helpers";
import Module from "../module/Module";

export default class Product {
    id;
    internal_id;
    website;
    category;
    active;
    spotlight;
    image;
    header_image;
    article_number;
    unit_price;
    stock;
    contents = [];
    media = [];

    constructor() {
        this.spotlight = false;
        this.content = new ProductContent();
        this.contents = [new ProductContent()];
    }

    static schema = (state) => {
        let fields = {
            title: Yup.string().required('CMS.Product.Content.Form.title').max(100, 'CMS.Product.Content.Form.title|100|max'),
            content: Yup.object({ text: Yup.string().required('CMS.Product.Content.Form.content') })
        };

        if (state.settings.use_categories) {
            fields.category = Yup.mixed().required('CMS.Product.Content.Form.category|select');
        }
        if (state.settings.use_webshop) {
            fields.unit_price = Yup.number()
                .transform((_, value) => parseFloat(value.replace(/,/g, '')))
                .typeError('CMS.Product.Content.Form.unit_price|number').required('CMS.Product.Content.Form.unit_price')
                .min(0, 'CMS.Product.Content.Form.unit_price|0|gte');
        }
        if (state.settings.show_article_number) {
            fields.article_number = Yup.string().required('CMS.Product.Content.Form.article_number').max(255, 'CMS.Product.Content.Form.article_number|255|max');
        }
        if (state.settings.show_stock) {
            fields.stock = Yup.number().integer().required('CMS.Product.Content.Form.stock').min(0, 'CMS.Product.Content.Form.stock|0|gte');
        }
        if (state.settings.show_summary) {
            fields.summary = Yup.string().required('CMS.Product.Content.Form.summary').max(255, 'CMS.Product.Content.Form.summary|255|max');
        }

        fields = Module.validateAdditionalField(state.module, state.lng, fields);

        return Yup.object(fields);
    }

    static fromJson = (json) => {
        let item = new Product();

        item.id = json.id;
        item.internal_id = json.internal_id;
        item.website = json.website;
        item.category = json.category;
        item.active = json.active;
        item.spotlight = json.spotlight;
        item.article_number = json.article_number;
        item.unit_price = PriceHelper.price(json.unit_price);
        item.stock = json.stock;
        item.image = json.image;
        item.header_image = json.header_image;
        item.contents = json.contents.map(content => ProductContent.fromJson(content));
        item.media = json.media;

        return item;
    }
}
